import BaseSetup from '@/components/BaseSetup';
import { useNotif } from '@orion.ui/orion';
import { debounce } from 'lodash-es';
import { nextTick, ref } from 'vue';

export type SharedDetailsListItemEmits = {
	(e: 'input', val: Undef<string>): void
};
export type SharedDetailsListItemProps = {
	editable?: boolean
	valueAlignRight?: boolean
	valueEllipsis?: boolean
	valueMaxWidth?: number
	legend?: string
	value?: string | number
	editionValueMaxLength?: number
	colClass?: string[]
};

export default class SharedDetailsListItemSetup extends BaseSetup {

	static readonly defaultProps = {
		editionValueMaxLength: 256,
		colClass: () => ['col-sm-5 col-md-4', 'col-sm-7 col-md-8'],
	};

	readonly contenteditable = ref(false);
	readonly _editionZone = ref<HTMLElement>();

	readonly handleEditableDebounced = debounce(this.handleEditable.bind(this), 100);

	constructor (
		private props: SharedDetailsListItemProps,
		private emits: SharedDetailsListItemEmits,
	) {
		super();
	}

	valueAdditionalStyle () {
		const styles = [];

		if (this.props.valueMaxWidth) {
			styles.push({ 'maxWidth': this.props.valueMaxWidth + 'px' });
		}

		return styles;
	}

	private handleEditable () {
		this.contenteditable.value = !this.contenteditable.value;

		if (this.contenteditable.value) {
			this.triggerEdition();
		}
		else {
			const newTitle = this._editionZone.value?.textContent?.trim();

			if (newTitle?.length && newTitle.length > (this.props.editionValueMaxLength ?? 256)) {
				// TODO: @i18n
				// useNotif.warning('Oops', `La limite de caractères est de ${this.props.editionValueMaxLength ?? 256} maximum`);
				useNotif.warning(this.$t('common.notification.oops'), this.$t('common.notification.maxCharactersLimit', { max: this.props.editionValueMaxLength ?? 256 }));
				this.handleEditable();
			}
			else {
				this.emits('input', newTitle);
			}
		}

	}

	private triggerEdition () {
		nextTick(() => {
			const el = this._editionZone.value;
			el?.setAttribute('tabindex', '1');
			if (el) {
				const range = document.createRange();
				range.selectNodeContents(el);
				const sel = window.getSelection();
				sel?.removeAllRanges();
				sel?.addRange(range);
				el.addEventListener('blur', this.handleEditableDebounced.bind(this), { once: true });
				el.focus();
			}
		});
	}

}
